import {Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from "@angular/material/dialog";
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ProgressBarComponent } from '../../progress-bar/progress-bar.component';
import { DecimalPipe } from '@angular/common';
export interface DialogData {
  expiredSession: boolean;
  countdown: number;
}

@Component({
    selector: 'app-idle-warning-modal',
    templateUrl: './idle-warning-modal.component.html',
    styleUrls: ['./idle-warning-modal.component.scss'],
    imports: [MatDialogTitle, MatDialogClose, CdkScrollable, MatDialogContent, ProgressBarComponent, MatDialogActions, DecimalPipe]
})
export class IdleWarningModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit() {  }

}
